import React, { Component } from 'react';
import { Modal, Row, Col, Spin, Form, Select, Input, TimePicker, Table, Tooltip, Button } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createHideTaskNoteModel, asyncTaskNoteUpdate, asynctaskNoteAdd } from './actions';
import Diff from './diff';
import moment from 'moment';
import { stringToTime } from '../../../utils';
moment.locale('zh-cn');
const FormItem = Form.Item;
const { TextArea } = Input;
const formItemLayout = {
    labelCol: { span: 4, offset: 2 },
    wrapperCol: { span: 16 },
};
class TimePairsSelect extends React.Component {
    selectChange(index, flag, value1, dateString) {
        const { value, onChange } = this.props;
        //通知父组件更新
        //封装数据传参
        let changeVal;
        //...
        if (index >= value.length) {
            if (flag == 1) {
                arr.put({ beginTime: dateString.replace(':', '') });
            } else {
                arr.put({ endTime: dateString.replace(':', '') });
            }
            changeVal = arr;
        } else {
            if (flag == 1) {
                value[index].beginTime = dateString.replace(':', '');
            } else {
                value[index].endTime = dateString.replace(':', '');
            }
            changeVal = value;
        }
        onChange(changeVal);
    }
    addTimePairs = () => {
        const { value, onChange } = this.props;
        value.push({ beginTime: 0, endTime: 0 });
        onChange(value);
    };
    delTimePairs = index => {
        const { value, onChange } = this.props;
        value.splice(index, 1);
        onChange(value);
    };
    render() {
        const { value } = this.props;
        const inputPile = []; //定义一个数组
        for (let i = 0; i < value.length; i++) {
            // for循环数组
            let index = i;
            inputPile.push(
                //将组件塞入定义的数组中
                <Row>
                    <Col span={18}>
                        <TimePicker
                            format="HH:mm"
                            placeholder="请输入"
                            /*   rules={[{
                                required: true,
                                message: '请输入时间段',
                                  },
                               ]}*/
                            value={moment(
                                stringToTime(value[index].beginTime == undefined ? '00' : value[index].beginTime),
                                'HH:mm',
                            )}
                            onChange={(value, dateString) => this.selectChange(index, 1, value, dateString)}
                        />
                        <TimePicker
                            format="HH:mm"
                            style={{ padding: '0 0 0 10px' }}
                            /* rules={[{
                             required: true,
                             message: '请输入时间段',
                         },
                         ]}*/
                            value={moment(
                                stringToTime(value[index].endTime == undefined ? '2359' : value[index].endTime),
                                'HH:mm',
                            )}
                            onChange={(value, dateString) => this.selectChange(index, 2, value, dateString)}
                        />
                    </Col>
                    {i == 0 ? (
                        <Col span={2} style={{ marginLeft: '5px' }}>
                            <Tooltip placement="top" title="添加时间段">
                                <Button
                                    shape="circle"
                                    icon="plus"
                                    size="small"
                                    type="primary"
                                    onClick={() => {
                                        this.addTimePairs();
                                    }}
                                />
                            </Tooltip>
                        </Col>
                    ) : (
                        <Col span={2} style={{ marginLeft: '5px' }}>
                            <Tooltip placement="top" title="删除时间段">
                                <Button
                                    shape="circle"
                                    icon="minus"
                                    size="small"
                                    type="danger"
                                    onClick={() => {
                                        this.delTimePairs(i);
                                    }}
                                />
                            </Tooltip>
                        </Col>
                    )}
                </Row>,
            );
        }

        return <div>{inputPile}</div>;
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Form.create()(TimePairsSelect));



// WEBPACK FOOTER //
// ./pages/task/tasklist/TimePairsSelect.js